import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  imports: [NgClass],
  standalone: true
})
export class ChipComponent {
  @Input() text = '';
  @Input() clickable = false;
  @Input() active = false;
  @Output() selected = new EventEmitter<string>();

  onChipSelect() {
    if (this.clickable) {
      const value = this.active ? '' : this.text;
      this.selected.emit(value);
      this.active = !this.active;
    }
  }
}
